import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { supplierThresholdDatesTypes } from 'actions/types'

const initialState = { items: [] }
const baseType = supplierThresholdDatesTypes.FETCH_SUPPLIER_THRESHOLD_DATES

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
